import { memo } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

const CheckingScopesPhase = memo(function CheckingScopesPhase({
  disabled,
  progressIcon,
  successIcon,
  errorIcon,
}: CheckingScopesPhaseProps): JSX.Element {
  return (
    <ServiceConnectionStep disabled={disabled}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {progressIcon ? <CircularProgress size="24px" sx={{ mr: 1 }} /> : null}
        {successIcon ? (
          <CheckCircleOutlineRoundedIcon color="success" sx={{ mr: 1 }} />
        ) : null}
        {errorIcon ? (
          <ErrorOutlineRoundedIcon color="error" sx={{ mr: 1 }} />
        ) : null}
        <Typography variant="body1">Checking enabled scopes</Typography>
      </Box>
      <Stack sx={{ mt: 2 }} spacing={1} direction="column">
        <Typography variant="body1">
          We check for enabled scopes in your Google Cloud Platform account. If
          you have any scopes that are not enabled, you will need to enable
          them. You can do this by following the steps below. If you have any
          questions, please contact your Success Team.
        </Typography>
      </Stack>
    </ServiceConnectionStep>
  );
});

export default CheckingScopesPhase;

// -----------------------------------------------------------------------------

interface CheckingScopesPhaseProps {
  disabled: boolean;
  progressIcon: boolean;
  successIcon: boolean;
  errorIcon: boolean;
}
